<section class="analytics-page insights-page">
  <div class="insights-shell">
    <header class="page-head">
      <div>
        <h1>Analytics</h1>
        <p>Pick a project to drill into its days and activity.</p>
      </div>
      <button type="button" class="primary-button" (click)="exportAll()">
        <i class="bi bi-download" aria-hidden="true"></i>
        Export
      </button>
    </header>

    <div class="filter-row">
      <app-analytics-filters
        [showProject]="true"
        [projects]="scopedProjects()"
        [projectUserIds]="projectUserIds()"
        [users]="projectUsers()"
        (filterChange)="onFilterChange($event)"
      />
      <span class="result-count">
        {{ rows().length }} {{ rows().length === 1 ? 'project' : 'projects' }}
      </span>
    </div>

    @if (loading()) {
      <section class="insights-state" aria-busy="true">
        <p>Loading analytics data…</p>
      </section>
    } @else {
      <div class="kpi-grid">
        <app-metric-card
          label="Total hours"
          [value]="(totals().total | number: '1.0-1') ?? ''"
          valueSuffix="h"
          [subtitle]="(totals().billable | number: '1.0-1') + ' h billable'"
          iconClass="bi bi-clock-history text-primary"
          [compact]="true"
        />
        <app-metric-card
          label="Approved"
          [value]="(totals().approved | number: '1.0-1') ?? ''"
          valueSuffix="h"
          [subtitle]="(totals().approvedBillable | number: '1.0-1') + ' h billable'"
          iconClass="bi bi-check2-circle text-success"
          [compact]="true"
        />
        <app-metric-card
          label="Pending review"
          [value]="(totals().pending | number: '1.0-1') ?? ''"
          valueSuffix="h"
          [subtitle]="(totals().pendingBillable | number: '1.0-1') + ' h billable'"
          iconClass="bi bi-hourglass-split text-warning"
          [compact]="true"
        />
        <app-metric-card
          label="Active contributors"
          [value]="totals().contributors"
          iconClass="bi bi-people text-primary"
          [compact]="true"
        />
      </div>

      <app-insights-charts
        [entries]="filteredEntries()"
        [projects]="scopedProjects()"
      />

      <section class="project-list card-surface" aria-label="Projects">
        <header class="list-head">
          <h2>Projects</h2>
          <app-search-input
            class="list-search"
            ariaLabel="Search projects"
            placeholder="Search projects…"
            [(value)]="projectSearch"
          />
        </header>

        @if (!rows().length) {
          <p class="empty-card">
            {{
              filter().userId
                ? 'No projects for this team member.'
                : 'No projects available.'
            }}
          </p>
        } @else if (!listedRows().length) {
          <p class="empty-card">
            No projects match "{{ projectSearch().trim() }}".
          </p>
        } @else {
          <div class="list-columns" aria-hidden="true">
            <span>Project</span>
            <span>Approval</span>
            <span>Hours</span>
            <span>Billable</span>
            <span>Team</span>
            <span>Last activity</span>
            <span></span>
          </div>
          @for (row of listedRows(); track row.id) {
            <a
              class="project-row"
              [routerLink]="['/analytics', row.id]"
              [queryParams]="{ projectId: null }"
              queryParamsHandling="merge"
            >
              <app-project-preview
                class="cell-project"
                [compact]="true"
                [logoUrl]="row.logoUrl"
                [color]="row.color"
                [name]="row.name"
                [description]="row.description"
              />
              <span class="cell-approval">
                <span class="approval-track">
                  <span
                    class="approval-fill"
                    [style.width.%]="row.approvedPercent"
                  ></span>
                </span>
                <small>
                  {{ row.approved | number: '1.0-1' }} approved
                  @if (row.pending) {
                    · {{ row.pending | number: '1.0-1' }} pending
                  }
                </small>
              </span>
              <b class="cell-hours">{{ row.hours | number: '1.0-1' }} h</b>
              <span class="cell-billable">
                {{ row.billableHours | number: '1.0-1' }} h
              </span>
              <span class="cell-team">
                @for (initials of row.contributors; track $index) {
                  <i class="member">{{ initials }}</i>
                }
                @if (row.contributorCount > row.contributors.length) {
                  <i class="member member--more">
                    +{{ row.contributorCount - row.contributors.length }}
                  </i>
                }
              </span>
              <span class="cell-last">
                {{ row.lastActivity ? (row.lastActivity | date: 'mediumDate') : '—' }}
              </span>
              <i class="bi bi-chevron-right chevron" aria-hidden="true"></i>
            </a>
          }
        }
      </section>
    }
  </div>
</section>
